import React, { useState } from 'react';
import api from '../lib/api';
import { useI18n } from '../context/I18nContext';
import { toast } from 'sonner';
import { MapPin, Phone, Mail, Loader2 } from 'lucide-react';

export default function Contact() {
  const { t } = useI18n();
  const [form, setForm] = useState({ name: '', email: '', phone: '', subject: '', message: '' });
  const [sending, setSending] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try { await api.post('/contact', form); toast.success(t('contact.success')); setForm({ name: '', email: '', phone: '', subject: '', message: '' }); }
    catch { toast.error('Error'); }
    finally { setSending(false); }
  };

  return (
    <div className="max-w-[1440px] mx-auto px-6 lg:px-12 py-16 lg:py-24" data-testid="contact-page">
      <p className="gn-overline mb-4">{t('nav.contact')}</p>
      <h1 className="font-serif text-5xl md:text-7xl text-[#f5f5f0] mb-6">{t('contact.title')}</h1>
      <p className="text-lg text-[#a3b5ad] font-light max-w-2xl mb-16">{t('contact.subtitle')}</p>

      <div className="grid lg:grid-cols-2 gap-16">
        <div className="space-y-10">
          <div>
            <p className="gn-overline mb-5">{t('contact.offices')}</p>
            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <MapPin size={20} className="text-[#c9a961] mt-1 flex-shrink-0" />
                <div>
                  <p className="font-serif text-xl text-[#f5f5f0]">Lugano</p>
                  <p className="text-sm text-[#a3b5ad]">Via Pretorio 11, 6901 Lugano, CH</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <MapPin size={20} className="text-[#c9a961] mt-1 flex-shrink-0" />
                <div>
                  <p className="font-serif text-xl text-[#f5f5f0]">Lugano</p>
                  <p className="text-sm text-[#a3b5ad]">Via Adriana Ramelli 1, 6900 Lugano, CH</p>
                </div>
              </div>
            </div>
          </div>
          <div>
            <p className="gn-overline mb-5">{t('contact.phone_label')}</p>
            <a href="tel:+41782008081" className="flex items-center gap-4 text-[#f5f5f0] hover:text-[#c9a961] mb-3"><Phone size={20} className="text-[#c9a961]" /><span className="font-serif text-xl">+41 78 200 8081</span></a>
            <a href="tel:+41792898008" className="flex items-center gap-4 text-[#f5f5f0] hover:text-[#c9a961]"><Phone size={20} className="text-[#c9a961]" /><span className="font-serif text-xl">+41 79 289 8008</span></a>
          </div>
          <div>
            <p className="gn-overline mb-5">{t('contact.email_label')}</p>
            <a href="mailto:info@gnwatches.com" className="flex items-center gap-4 text-[#f5f5f0] hover:text-[#c9a961]"><Mail size={20} className="text-[#c9a961]" /><span className="font-serif text-xl">info@gnwatches.com</span></a>
          </div>
        </div>

        <form onSubmit={submit} className="space-y-7" data-testid="contact-form">
          <div className="grid grid-cols-2 gap-6">
            <div><label className="gn-overline mb-3 block">{t('contact.name')} *</label><input required className="gn-input" value={form.name} onChange={(e) => setForm({...form, name: e.target.value})} data-testid="contact-name" /></div>
            <div><label className="gn-overline mb-3 block">{t('contact.email')} *</label><input required type="email" className="gn-input" value={form.email} onChange={(e) => setForm({...form, email: e.target.value})} data-testid="contact-email" /></div>
          </div>
          <div className="grid grid-cols-2 gap-6">
            <div><label className="gn-overline mb-3 block">{t('contact.phone')}</label><input className="gn-input" value={form.phone} onChange={(e) => setForm({...form, phone: e.target.value})} data-testid="contact-phone" /></div>
            <div><label className="gn-overline mb-3 block">{t('contact.subject')}</label><input className="gn-input" value={form.subject} onChange={(e) => setForm({...form, subject: e.target.value})} data-testid="contact-subject" /></div>
          </div>
          <div><label className="gn-overline mb-3 block">{t('contact.message')} *</label><textarea required className="gn-textarea" value={form.message} onChange={(e) => setForm({...form, message: e.target.value})} data-testid="contact-message" /></div>
          <button type="submit" disabled={sending} className="gn-btn-primary" data-testid="contact-submit">
            {sending && <Loader2 className="animate-spin" size={16} />}
            {t('contact.send')}
          </button>
        </form>
      </div>
    </div>
  );
}
